import { useEffect } from "react";
import { useSymbolsWatchlistStore } from "./store";

export const initializeSymbolsWatchlist = () => {
  const { loadWatchlist } = useSymbolsWatchlistStore.getState();
  loadWatchlist();
};

export const useSymbolsWatchlist = () => {
  const store = useSymbolsWatchlistStore();

  // Initialize on mount
  useEffect(() => {
    initializeSymbolsWatchlist();
  }, []);

  return {
    watchlist: store.watchlist,
    addSymbol: store.addSymbol,
    removeSymbol: store.removeSymbol,
    setWatchlist: store.setWatchlist,
    clearWatchlist: store.clearWatchlist,
    isSymbolInWatchlist: store.isSymbolInWatchlist,
  };
};

export const useWatchlistSymbolsCount = () => {
  return useSymbolsWatchlistStore(state => state.watchlist.length);
};

export const useIsSymbolInWatchlist = (symbol: string) => {
  return useSymbolsWatchlistStore(state => state.watchlist.includes(symbol));
};
